import * as React from 'react';
import { Role } from './constants';

export const Context = React.createContext({
    /** Whether app is running in debug mode */
    debug: false,
    role: [Role.None],
    userId: 0
});
